/* eslint-disable react/prop-types */
import React from "react";
import { Link } from "react-router-dom";
import { INVOICE_DETAILS, CLIENT_DETAILS } from "../../../../../route/paths";
import { accountsReceivableData } from "../../../../../locales/en";
import {
  formatCurrencyWithSign,
  formatFTNumber,
  formatDateWithDayjs
} from "../../../../../utils/utils";
import {
  CURRENCY_FORMAT,
  NEGATIVE_SIGN,
  DD_MMM_YYYY,
  ZERO_NUMBER
} from "../../../../../utils/constants/appConstants";

const { headers } = accountsReceivableData;

/**
 * Renders a money column. A negative balance is a credit: the client paid more than the
 * amount that was due, so the minus sign goes in front of the currency symbol.
 */
const MoneyCell = ({ value }) => {
  if (value === null || value === undefined) return NEGATIVE_SIGN;
  const isNegative = value < ZERO_NUMBER;
  return (
    <span className={isNegative ? "text-danger" : ""}>
      {isNegative ? NEGATIVE_SIGN : ""}
      {CURRENCY_FORMAT}
      {formatCurrencyWithSign(Math.abs(value))}
    </span>
  );
};

const DateCell = ({ value }) =>
  formatDateWithDayjs(value, DD_MMM_YYYY) || NEGATIVE_SIGN;

const TextCell = ({ value }) => value || NEGATIVE_SIGN;

export const COLUMNS = [
  {
    Header: headers.clientName,
    accessor: "clientName",
    Cell: ({ value, row }) =>
      row?.original?.userAccountId ? (
        <Link to={CLIENT_DETAILS(row.original.userAccountId)}>
          {value || NEGATIVE_SIGN}
        </Link>
      ) : (
        value || NEGATIVE_SIGN
      )
  },
  {
    Header: headers.quoteId,
    accessor: "quoteId",
    Cell: ({ value }) => (
      <Link to={INVOICE_DETAILS(value)}>
        {formatFTNumber(value) || NEGATIVE_SIGN}
      </Link>
    )
  },
  {
    Header: headers.invoiceNumber,
    accessor: "invoiceNumber",
    Cell: TextCell
  },
  {
    Header: headers.fundedDate,
    accessor: "fundedDate",
    Cell: DateCell
  },
  {
    Header: headers.repayDate,
    accessor: "repayDate",
    Cell: DateCell
  },
  {
    Header: headers.quoteStatus,
    accessor: "quoteStatus",
    Cell: TextCell
  },
  {
    Header: headers.principal,
    accessor: "principal",
    Cell: MoneyCell
  },
  {
    Header: headers.fee,
    accessor: "fee",
    Cell: MoneyCell
  },
  {
    Header: headers.overdueFee,
    accessor: "overdueFee",
    Cell: MoneyCell
  },
  {
    Header: headers.overduePaFee,
    accessor: "overduePaFee",
    Cell: MoneyCell
  },
  {
    Header: headers.manualPartPayments,
    accessor: "manualPartPayments",
    Cell: MoneyCell
  },
  {
    Header: headers.paymentsReceived,
    accessor: "paymentsReceived",
    Cell: MoneyCell
  },
  {
    Header: headers.balanceOwing,
    accessor: "balanceOwing",
    Cell: MoneyCell
  }
];
